"use strict";

module.exports = {
    activityStates: {
        run: "run",
        end: "end",
        complete: "complete",
        cancel: "cancel",
        idle: "idle",
        fail: "fail"
    },
    workflowEvents: {
        start: "start",
        invoke: "invoke",
        end: "end",
        warn: "warn",
        workflowEvent: "workflowEvent"
    },
    events: {
        workflowEvent: "workflowEvent"
    }
};
